import React, { useEffect, useState } from "react";
import { Typography, Box, Button, MenuItem, Select } from "@mui/material";
import Link from "@mui/material/Link";
import ImageUploadBanner from "./ImageUploderBanner";
import BannerTable from "./BannerTable";
import { craetebannersonly, craetebrandsonly, editbannersonly, getalllocations, getbannerapprovalhistory, getbannerdetailsbyid, uploadimage } from "./api";
import { getToken } from "../../utils/utils";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Warning from "../../../src/assests/images/warning-2.svg";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import Fiveimguploader from "./Fiveimguploader";
import Fileupload from "../../components/FileuploadWithPreview/Fileupload";
import Arrowup from "../../../src/assests/images/arrow_up_download.svg";
import warn from "../../../src/assests/images/warn.svg";
import ArrowDownCurve from "../../../src/assests/images/arrow-down-curve.svg";
import { first } from "lodash";
import ReportDropdown from "../reports/Reportdropdown";
import CSVUpload from "./CSVUpload";

interface Banner {
  id: string;
  banner_name: string;
  type: string;
  large_banner_image: string;
  image_path: string;
  banner_locations: string[];
  status: string;
}
interface RowData {
  id: number;
  requested_on: string;
  banner_images: string;
  status: string;
  brands_banner_approved_by: string;
}

interface UploadedImage {
  src: string;
  source: "first" | "additional";
}
interface DefaultImagePath {
  large_banner_image?: string;
  banner_images?: string;
  available_Locations?: string
}

interface Option {
  label: string;
  value: string;
}


export default function AddBanner() {
  const [uploadedImage, setuploadedImage] = useState();
  const [imagePath, setImagePath] = useState<string>("");
  const [brandName, setBrandName] = useState<string>("");
  const [defaultimagepath, setdefaultimagepath] = useState<DefaultImagePath>({});
  const [type, setType] = useState<string>("");
  const [refreshKey, setRefreshKey] = useState<number>(0);
  const [isUploading, setIsUploading] = useState(false);
  const token = getToken();
  const { showAlert } = useAlert();
  const predefinedImageUrls = [Warning];
  const location = useLocation();
  const { fileName } = location.state || {};
  const [selectedValue, setSelectedValue] = useState<string[]>(
    Array.isArray(defaultimagepath.available_Locations) ? defaultimagepath.available_Locations : []
  );
  const [images, setImages] = useState<{ url: string; source: string }[]>([]);
  const [imageupload, setimageupload] = useState<UploadedImage[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<string[]>([]);

  const [locationsall, setlocations] = useState<string[]>([]);

  const [brandapprovalhistory, setbrandapprovalhistory] = useState<RowData[]>([]);

  const [addbrandhistory, setaddbrandhistory] = useState<RowData[]>([]);
const navigate = useNavigate();

  const { bannerId } = useParams();

  console.log(bannerId, "bannerIdbannerId")



  useEffect(() => {
    if (fileName && fileName !== imagePath) {
      setImagePath(fileName);
    }
  }, [fileName, imagePath]);



  const uploadimagesapicall = async (file: File) => {
    const token = getToken();
    if (!token) {
      alert("Please log in to upload files.");
      return null;
    }

    const formData = new FormData();
    formData.append("answer", file);

    try {
      const response = await uploadimage(formData, token);
      const uploadedFileName = response.data.fileName;


      setimageupload((prev) => {
        const newImage: UploadedImage = {
          src: uploadedFileName,
          source: prev.length === 0 ? "first" : "additional",
        };

        return [...prev, newImage];
      });

      return response.data.fileName;
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Image upload failed.");
      return null;
    }
  };

  console.log(imageupload, "imageuploadimageupload54334")


  useEffect(() => {
    const fetchDropdownCities = async () => {
      try {
        const response = await getalllocations();
        console.log(response.data.data, "API Response");
        setlocations(response.data.data)
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchDropdownCities();
  }, []);



  useEffect(() => {
    if (bannerId) {
      const fetchDropdownCities = async () => {
        try {
          const requestBody = {
            brand_banner_id: bannerId,
          };

          const response = await getbannerdetailsbyid(requestBody, token);
          console.log(response.data.data, "API Response banner");
          setdefaultimagepath(response.data.data);

        } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };

      fetchDropdownCities();
    }
  }, [bannerId, token]);







  console.log(defaultimagepath, "defaultimagepathhhhhhhhhhwww")


  const baseUrl = process.env.REACT_APP_API_URL + "/uploads/";
  console.log(imageupload, "imageuploadimageuploadimageuploadimageuploadimageuploadimageupload")
  const handleAddBanner = async () => {
    showAlert("Adding Banner...", "info");

    if (!token) {
      console.error("Token is missing!");
      return;
    }

    const reqBody: Banner = {
      id: bannerId ? String(bannerId) : "",
      banner_name: brandName,
      type: "banners",

      large_banner_image: images
        .find(item => item.source === "first")?.url.replace(baseUrl, "") || "",

      image_path: images
        .filter(item => item.source === "additional")
        .map(item => item.url.replace(baseUrl, ""))
        .join(","),
      banner_locations: selectedLocation,
      status: "PENDING_APPROVAL",
    };

    if (bannerId) {
      reqBody.id = String(bannerId);
    }

    try {
      const response = bannerId
        ? await editbannersonly(reqBody, token)
        : await craetebannersonly(reqBody, token);
      if (bannerId) {
        fetchBannerApprovalHistory();
      } else {
        const formattedData: RowData[] = response.data.data.map((item: any) => ({
          id: item.id,
          requested_on: new Date(item.created_at).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          banner_images: [item.image_path, item.large_banner_image].filter(Boolean).join(", "),
          status: item.status,
          brands_banner_approved_by: "yashavanth",
        }));
        setbrandapprovalhistory(formattedData);
      }
      console.log("Banner added successfully:", response);
      setRefreshKey((prev) => prev + 1);
      showAlert(bannerId ? "Banner edit successfully!" : "Banner added successfully!", "success");
      
      //  navigate(`/brands`);
        // setTimeout(() => window.location.reload(), 100);

    } catch (error) {
      console.error("Error adding banner:", error);
      showAlert("An error occurred while adding the banner", "error");
    }
  };

  const fetchBannerApprovalHistory = async () => {
    if (!bannerId) return;
    try {
      const requestBody = { brand_banner_id: bannerId };
      const response = await getbannerapprovalhistory(requestBody, token);
      console.log(response.data.data, "API Response approvalhistory");

      const formattedData: RowData[] = response.data.data.map((item: any) => ({
        id: item.id,
        requested_on: item.requested_on,
        banner_images: item.banner_images,
        status: item.status,
        brands_banner_approved_by: item.brands_banner_approved_by || "N/A",
      }));

      setbrandapprovalhistory(formattedData);
    } catch (error) {
      console.error("Error fetching approval history:", error);
    }
  };

  useEffect(() => {
    if (bannerId) {
      fetchBannerApprovalHistory();
    }
  }, [bannerId, token]);



  console.log(selectedValue, "selectedValueselectedValue")
  console.log(images, "imagesimagesimages")
  console.log(brandapprovalhistory, "brandapprovalhistoryeeeeeeeee")



  useEffect(() => {
    if (Array.isArray(defaultimagepath.available_Locations)) {
      setSelectedLocation(
        defaultimagepath.available_Locations.flatMap((loc) => loc.split(",")) // Ensure array format
      );
    }
  }, [defaultimagepath]);


  const handleLocationChange = (selected: Option[] | null) => {
    setSelectedLocation(selected ? selected.map((opt) => opt.value) : []);
  };


  console.log(selectedLocation, "selectedLocationeeeeeeewwwwwww")
  return (
    <div>
      <Box sx={{ padding: "28px 32px 0" }}>
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ display: "flex", fontSize: "14px", color: "#696A6B" }}>
            Banner /
            <Typography sx={{ color: "#8E020F", fontWeight: "500", fontSize: "14px" }}>
              {bannerId ? "Edit Banner" : "Add Banner"}
            </Typography>
          </Typography>
        </Box>
        <Typography sx={{ color: "#282829", fontWeight: "600", fontSize: "24px", padding: "16px 0 0" }}>  {bannerId ? "Edit Banner" : "Add Banner"}</Typography>
      </Box>

      <Box sx={{ display: "flex", width: "98%", padding: "0 10px 0 32px", }}>
        <Box sx={{ width: "100%", borderTop: "1px solid #E7E8E9", paddingTop: "6px", marginTop: "16px" }}>
          <Typography sx={{ color: "#282829", fontWeight: "600", fontSize: "18px", padding: "16px 0 0", marginBottom: "2px" }}>Upload Images </Typography>
          <Typography sx={{ color: "#696A6B", fontWeight: "400", fontSize: "16px", marginBottom: "24px" }} variant="body1">Upload the banner images below, which will be showcased at the top of the brands for retailers to see.</Typography>

          <label style={{ color: "#282829", fontSize: "16px", fontWeight: "500", marginBottom: "8px" }}>Select Location*</label>
          <Box sx={{ position: "relative", marginTop: "8px", display: "flex", alignItems: "center", gap: "24px", marginBottom: "24px" }}>

            {/* <ReactDropdown
              options={[{ value: "", label: "All Locations" }, ...locationsall.map(loc => ({ value: loc, label: loc }))]}
              placeholder="Select Location"
              value={selectedLocation}
              onChange={handleLocationChange}
            /> */}
            <ReportDropdown
              options={[{ value: "", label: "All Locations" }, ...locationsall.map(loc => ({ value: loc, label: loc }))]}
              placeholder="Select Location"
              value={selectedLocation}
              onChange={handleLocationChange}
              
            />
            {/* <Fileupload
                fileuploadclass="editbanner-upload"
                iconSrc={Arrowup}
                onFileSelect={(file) => console.log("Selected file:", file)}
                previewSize={{ width: 16, height: 16 }}
                onRemoveFile={() => console.log("File removed!")}
              /> */}
            <Box>
              <CSVUpload />
            </Box>
          </Box>

          <Fiveimguploader images={images} setImages={setImages} uploadimagesapicall={uploadimagesapicall} large_banner_image={defaultimagepath.large_banner_image || ""} additionalimages_banner_image={defaultimagepath.banner_images || ""} />
          
           <Box sx={{ display: "flex",gap:"8px",alignItems: "center",padding: "8px 10px",background: "rgba(245, 230, 150, 0.40)",fontSize: "14px",fontWeight:"400",color:"#282829",margin:"24px 0 30px",borderRadius:"6px"}}>
              <img src={warn} alt="" />
              Note: Clicking “Submit” will trigger an email to project owner abc@pmintl.com for approval.
            </Box>

          {/* <ImageUploadBanner
            headTitle="Add Banner"
            title="Upload Image"
            subtitle=" Upload the banner images below, which will be showcased at the top of
            the brands for retailers to see."
            note="  Note: Any extension of active task will trigger an email to project
            owner abc@pmintl.com for approval."
            uploadText=" Drag & Drop your Image/Gif here or Choose file"
            uploadSize={" PNG, JPG,GIF,SVG (Max 5 MB)"}
            addMoreText={"Can add upto 5 Images"}
            imageUrls={predefinedImageUrls}
            setuploadedImage={setuploadedImage}
          /> */}
        </Box>
      </Box>
      <Box sx={{ padding: "30px 32px" }}>
        <BannerTable refreshKey={refreshKey} brandapprovalhistory={brandapprovalhistory} />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
          background: "#fff",
          fontSize: "14px",
        }}
      >
        <Link href="/" underline="none" sx={{ color: "#C8172F" }}>
          {"← Back"}
        </Link>
        <Button
          onClick={handleAddBanner}
          variant="contained"
          color="primary"
          disabled={images.length === 0}
          sx={{
            background: "#C8172F",
            color: "#fff",
            width: "200px",
            padding: "10px 0",
            textTransform: "capitalize",
            fontSize: "14px",
          }}
        >
          Submit
        </Button>
      </Box>
    </div>
  );
}
